import { TypographyProps, Typography } from "@commonlibs";

export const PasswordHint = (props: Omit<TypographyProps, "variant">) => <Typography variant="body4Medium" light {...props} />;
